var Api = require('js/api');
var Collection = require('js/lib/collection');
var Activities = require('js/collections/activities');
var config = require('js/config');

/**
 * Notifications
 * @exports Notifications
 * @constructor
 * @alias module:collections/notifications
 */
var Notifications = Activities.extend({
  url: config.build.apiPath + '/private/notifications/items',
  unreadUrl: config.build.apiPath + '/private/notifications/unread',
  accumulate: false,
  paginationType: Collection.PAGINATION_TYPES.FROM_SIZE,
  unreadTotal: 0,
});

/**
 * Fetch with a size of 0 so we just extract the meta data
 */
Notifications.prototype.fetchMeta = function() {
  return Api.get(this.unreadUrl).then(function(payload) {
    this.unreadTotal = payload.unread;
  }, this);
};


module.exports = Notifications;



// WEBPACK FOOTER //
// ./app/assets/js/collections/notifications.js